document.addEventListener("DOMContentLoaded", function () {
  // Get the hero image by ID
  const characterImg = document.getElementById("character_img");
  const blurredImg = document.querySelector(".blurred");

  try {
    if (blurredImg) {
      if (characterImg.complete) {
        // Image already loaded (from cache)
        handleImageLoaded();
      } else {
        // Image still loading
        blurredImg.style.opacity = 1;
        characterImg.addEventListener("load", handleImageLoaded);
      }

      function handleImageLoaded() {
        // Add loaded class to show the full image
        characterImg.classList.add("loaded");

        // Optional: fade out the blurred image after a short delay
        setTimeout(() => {
          if (blurredImg) blurredImg.style.opacity = 0;
        }, 500);
      }
    }
  } catch (error) {
    const blurredImg = document.querySelector(".blurred");

    if (characterImg) {
      characterImg.style.opacity = 1;
      characterImg.classList.add("loaded");
    }

    if (blurredImg) {
      blurredImg.style.opacity = 0;
    }

    // Optional: log the error for debugging
    console.error("Error in banner image script:", error);
  }

  if (characterImg) {
    // Initial position
    let initialOffset = 0;
    let initialScale = 1;
    let maxScale = 1.05; // Maximum scale value to reach
    let maxTranslate = 220; // Maximum translation in pixels

    // Set initial transform on load
    characterImg.style.transform = `translateY(${initialOffset}px) scale(${initialScale})`;
    characterImg.style.transition = "transform 0.1s ease-out";

    // Set transform origin to center for balanced scaling
    characterImg.style.transformOrigin = "center center";

    // Parallax function
    function updateParallax() {
      const scrollPosition = window.pageYOffset;

      // For scale, calculate what scroll position should trigger maximum scale
      const scrollDistanceForMaxEffects = 800; // Adjust based on your needs

      // Calculate progress (0 to 1) based on scroll position
      const scrollProgress = Math.min(
        1,
        scrollPosition / scrollDistanceForMaxEffects
      );

      // Calculate scale that increases from 1 to 1.2
      const scaleValue =
        initialScale + (maxScale - initialScale) * scrollProgress;

      // Calculate translation that increases from 0 to maxTranslate (30px)
      const translateOffset = Math.min(maxTranslate, scrollPosition * 0.1);

      // Apply both transforms together
      characterImg.style.transform = `translateY(${translateOffset}px) scale(${scaleValue})`;
    }

    // Listen for scroll events
    window.addEventListener("scroll", function () {
      // Use requestAnimationFrame for better performance
      window.requestAnimationFrame(updateParallax);
    });

    // Update on resize
    window.addEventListener("resize", function () {
      window.requestAnimationFrame(updateParallax);
    });

    // Call once on load to set initial state
    updateParallax();
  }
});

document.querySelector("#character_img").addEventListener("load", function () {
  document.querySelector(".blurred").style.opacity = 0;
});
